<div class="confirm-modal ig-modal source-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div>
        <div class="title">Eventbrite pulling status</div>
    </div>

    <div style="max-height: 450px;overflow-y: auto;padding: 16px 0">
        <div *ngFor="let eb of eventbrite" class="text-left">
            {{ eb }}
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/event.pulling.status/event.pulling.status.modal.component.html